'use client'

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/blocks/components/ui/tabs'
import { PublicTimingWindowDto } from '@/server/public-api/types'

import Plan from './plan'

type PricingPlansProps = {
  timingWindows: PublicTimingWindowDto[]
  defaultWindowId?: number
  disableSwitch?: boolean
}

const PricingPlans = ({ timingWindows, defaultWindowId, disableSwitch }: PricingPlansProps) => {
  if (timingWindows.length === 0) return null

  const activeId = defaultWindowId ?? timingWindows[0].id

  return (
    <section>
      <Tabs defaultValue={String(activeId)}>
        <div className='mb-6 flex justify-center'>
          <TabsList className={`bg-[#A4AFAE] ${disableSwitch ? 'pointer-events-none' : ''}`}>
            {timingWindows.map(tw => (
              <TabsTrigger key={tw.id} value={String(tw.id)} className='data-[state=active]:bg-secondary'>
                {tw.name}
              </TabsTrigger>
            ))}
          </TabsList>
        </div>
        {timingWindows.map(tw => (
          // forceMount keeps every window's plans in the server HTML so all prices
          // stay crawlable. Radix does NOT hide force-mounted panels itself, so the
          // inactive ones are hidden by their data-state.
          <TabsContent key={tw.id} forceMount className='data-[state=inactive]:hidden' value={String(tw.id)}>
            <ul className='grid grid-cols-[repeat(auto-fit,17rem)] place-content-center gap-x-14 gap-y-16'>
              {tw.pricingPlans.map((plan, index) => (
                <li key={plan.id}>
                  <Plan
                    plan={plan}
                    timeWindowName={tw.name}
                    className={index % 2 !== 0 ? 'bg-primary' : 'bg-secondary'}
                  />
                </li>
              ))}
            </ul>
          </TabsContent>
        ))}
      </Tabs>
    </section>
  )
}

export default PricingPlans
